// extracted by mini-css-extract-plugin
export default {"value":"ZwgLevel_value__v-0Rm","wrapper":"ZwgLevel_wrapper__6qlmQ"};